import React from 'react';

const Comparison: React.FC = () => {
    return (
        <section id="comparison" className="comparison">
            <div className="container">
                <div className="comparison-header">
                    <h2>Choosing the Right Professional</h2>
                    <div className="comparison-divider"></div>
                </div>
                <div className="comparison-grid">
                    <div className="comparison-card">
                        <div className="comparison-card-icon-wrapper">
                            <i className="fas fa-user-md" aria-hidden="true"></i>
                        </div>
                        <h3>Physiotherapist</h3>
                        <div className="comparison-card-content">
                            <div className="comparison-section">
                                <h4>Qualifications</h4>
                                <p>Bachelor's or Master's degree in Physiotherapy. Must be registered with the Health and Care Professions Council (HCPC) in the UK.</p>
                            </div>
                            <div className="comparison-section">
                                <h4>Scope of Practice</h4>
                                <p>Focuses on diagnosing and treating injuries, pain, and movement disorders. Uses manual therapy, exercise, and education to restore function.</p>
                            </div>
                            <div className="comparison-section">
                                <h4>When to See</h4>
                                <p>For acute injuries, post-surgical rehabilitation, chronic pain management, and movement dysfunction. Often works with medical referrals.</p>
                            </div>
                        </div>
                    </div>

                    <div className="comparison-card comparison-card--featured">
                        <div className="comparison-card-icon-wrapper">
                            <i className="fas fa-heartbeat" aria-hidden="true"></i>
                        </div>
                        <h3>Exercise Physiologist</h3>
                        <div className="comparison-card-content">
                            <div className="comparison-section">
                                <h4>Qualifications</h4>
                                <p>Bachelor's or Master's degree in Exercise Physiology or Clinical Exercise Science. AHCS registered (Academy for Health Care Sciences). CEP-UK accredited (Clinical Exercise Physiology UK).</p>
                            </div>
                            <div className="comparison-section">
                                <h4>Scope of Practice</h4>
                                <p>Bridges the gap between physiotherapy and strength & conditioning. Uses evidence-based exercise prescription for injury rehabilitation, chronic disease management, and performance enhancement. Combines clinical expertise with exercise science.</p>
                            </div>
                            <div className="comparison-section">
                                <h4>When to See</h4>
                                <p>Ideal for those needing exercise-based rehabilitation, chronic condition management (diabetes, heart disease, cancer recovery), injury prevention, and long-term health optimization. Perfect for bridging recovery to performance.</p>
                            </div>
                        </div>
                    </div>

                    <div className="comparison-card">
                        <div className="comparison-card-icon-wrapper">
                            <i className="fas fa-dumbbell" aria-hidden="true"></i>
                        </div>
                        <h3>Personal Trainer</h3>
                        <div className="comparison-card-content">
                            <div className="comparison-section">
                                <h4>Qualifications</h4>
                                <p>Various certifications (Level 2/3 Personal Training, NASM, ACE, etc.). Not a regulated healthcare profession. Focus on fitness and general wellness.</p>
                            </div>
                            <div className="comparison-section">
                                <h4>Scope of Practice</h4>
                                <p>Designs fitness programs for general health, weight management, and athletic performance. Works with healthy individuals or those cleared for exercise. Cannot diagnose or treat medical conditions.</p>
                            </div>
                            <div className="comparison-section">
                                <h4>When to See</h4>
                                <p>For general fitness goals, weight loss, muscle building, and athletic performance when you're healthy and injury-free. Not suitable for injury rehabilitation or chronic disease management.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Comparison;
